export default __webpack_public_path__ + "static/media/new-members.c511d37f.webp";